import allBlogs from '../data/blogs.json';

// Keep titles minimal: drop emoji and collapse the leftover whitespace.
function plainTitle(title) {
  return (title || '')
    .replace(/[\p{Extended_Pictographic}\u{1F1E6}-\u{1F1FF}\u200D\uFE0F]/gu, '')
    .replace(/\s+/g, ' ')
    .trim();
}

// blogs.json is generated at build time by scripts/fetch-notion.js
export const blogs = allBlogs
  .filter((b) => b.status !== 'Not started')
  .map((b) => ({ ...b, title: plainTitle(b.title) }));

export const isPublished = (blog) => blog.status === 'Done';

export const blogPath = (blog) => `/blog/${blog.slug || blog.id}`;

export function findBlog(param) {
  return blogs.find((b) => b.slug === param || b.id === param);
}

export function formatDate(iso, style = 'short') {
  if (!iso) return '';
  const opts =
    style === 'long'
      ? { day: 'numeric', month: 'long', year: 'numeric' }
      : { day: '2-digit', month: 'short', year: 'numeric' };
  // noon avoids a timezone shift to the previous day
  return new Intl.DateTimeFormat('en-GB', opts).format(new Date(`${iso}T12:00:00`));
}

export function readingTime(blocks) {
  const words = (blocks || [])
    .flatMap((b) => b.content || [])
    .map((s) => s.text)
    .join(' ')
    .split(/\s+/)
    .filter(Boolean).length;
  return Math.max(1, Math.round(words / 220));
}
